import { httpClient } from '../../../core/network';

// The backend forwards identity's user-facing message as `errorMessage`.
const withIdentityMessage = (e: any) => {
  const message = e?.response?.data?.errorMessage;
  return message ? new Error(message) : e;
};

export class UserService {
  static searchUsers(params: Record<string, any>, page = 1, limit = 20) {
    const apiUrl = '/auth0/users';
    return httpClient.get(apiUrl, {
      params: { ...params, page, limit },
    });
  }

  static fetchUser(userId: string) {
    const apiUrl = `/auth0/users/${userId}`;
    return httpClient.get(apiUrl);
  }

  static fetchUserByEmail(email: string) {
    const apiUrl = '/auth0/users';
    return httpClient.get(apiUrl, {
      params: { searchterm: email, page: 1, limit: 1 },
    });
  }

  static updateUser(userId: string, userData: Record<string, any>) {
    const apiUrl = `/auth0/users/${userId}`;
    return httpClient.put(apiUrl, userData);
  }

  static sendVerificationEmail(userId: string) {
    const apiUrl = `/auth0/verificationemail`;
    return httpClient.post(apiUrl, {
      emailRequest: { uuid: userId },
    });
  }
  static async resetPassword(userId: string) {
    const apiUrl = `/auth0/users/${encodeURIComponent(userId)}/password`;
    const response = await httpClient.post(apiUrl).catch(e => {
      throw withIdentityMessage(e);
    });

    const newPassword = response?.data?.newPassword;

    if (!newPassword) {
      throw new Error('Failed getting new password');
    }

    return newPassword;
  }

  static sendPasswordResetEmail(userId: string) {
    const apiUrl = `/auth0/resetpassword`;
    return httpClient.post(apiUrl, {
      emailRequest: { uuid: userId },
    });
  }

  static logoutAllDevices(userId: string) {
    const apiUrl = `/auth0/users/${userId}/logout-all-devices`;
    return httpClient.delete(apiUrl);
  }

  static closeUser(userId: string) {
    const apiUrl = `/auth0/users/${userId}`;
    return httpClient.delete(apiUrl);
  }

  static reopenUser(userId: string) {
    const apiUrl = `/auth0/users/${userId}/status`;
    return httpClient.put(apiUrl, { status: 'A' });
  }

  static removeBlocks(userId: string) {
    const apiUrl = `/auth0/users/${userId}/blocks`;
    return httpClient.delete(apiUrl);
  }

  static createUser(userData: string) {
    const apiUrl = '/auth0/users';
    return httpClient.post(apiUrl, userData).catch(e => {
      throw withIdentityMessage(e);
    });
  }
}

export default UserService;
